module.exports = __webpack_public_path__ + "img/rede-2025-01.a4dbbfa4.jpg";